import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32 12V38",
			stroke: "currentColor",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 29L32 39L42 29",
			stroke: "currentColor",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 44V50C18 51.1046 18.8954 52 20 52H44C45.1046 52 46 51.1046 46 50V44",
			stroke: "currentColor",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDownload;
